export const postMessageMinMax = {
    min: 20,
    // max: 50
}